/**
 * Initialise la carte Google Maps pour la page partenaire
 */
function initPartnerMap() {
  var mapElement = document.getElementById("partner-map");
  if (!mapElement) {
    return;
  }

  // Récupérer les données depuis les data-attributes
  var lat = parseFloat(mapElement.getAttribute("data-lat"));
  var lng = parseFloat(mapElement.getAttribute("data-lng"));
  var zoom = parseInt(mapElement.getAttribute("data-zoom")) || 15;
  var address = mapElement.getAttribute("data-address") || "";

  if (isNaN(lat) || isNaN(lng)) {
    return;
  }

  if (typeof google === "undefined" || !google.maps) {
    console.error("Google Maps API is not loaded");
    return;
  }

  // Créer la carte
  var map = new google.maps.Map(mapElement, {
    center: { lat: lat, lng: lng },
    zoom: zoom,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scaleControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    cameraControl: false,
    styles: [
      {
        featureType: "all",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "2.00",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#9c9c9c",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f2f2f2",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#7b7b7b",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#46bcec",
          },
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#c8d7d4",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#070707",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
    ],
  });

  // Créer le marqueur avec le même pin que les revendeurs
  var MARKER_ICON_SIZE_REVENDEUR = { width: 18.87, height: 25 };
  // Construire l'URL de l'icône revendeur (même que dans store-locator.js)
  var iconUrl =
    window.location.origin +
    "/wp-content/themes/data_theme/assets/icons/store-locator/revendeurs-icon.svg";

  var icon = {
    url: iconUrl,
    scaledSize: new google.maps.Size(
      MARKER_ICON_SIZE_REVENDEUR.width,
      MARKER_ICON_SIZE_REVENDEUR.height,
    ),
  };

  var marker = new google.maps.Marker({
    position: { lat: lat, lng: lng },
    map: map,
    title: address,
    icon: icon,
  });
}

// Attendre que Google Maps soit chargé
if (typeof google !== "undefined" && google.maps) {
  // Si déjà chargé, initialiser immédiatement
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPartnerMap);
  } else {
    initPartnerMap();
  }
} else {
  // Si Google Maps n'est pas encore chargé, attendre le callback
  window.initPartnerMap = initPartnerMap;
}

(_axcb = window._axcb || []).push(function (sdk) {
  sdk.on("cookies:complete", function (choices) {
    if (choices.gmaps) {
      // Cle Google Maps (depuis .env via Parcel)
      const googleApiKey = process.env.GOOGLE_MAPS_API_KEY;

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&callback=initPartnerMap&libraries=places,geometry&loading=async`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  document
    .getElementById("acf-gmap-accept-cookies")
    .addEventListener("click", function () {
      sdk.openCookies();
    });
});

// Date picker personnalisé pour le délai de réalisation
document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("delai-realisation");
  const dateDisplay = document.getElementById("delai-realisation-display");
  const dateWrapper = document.getElementById("delai-realisation-wrapper");
  const dateIcon = document.getElementById("delai-realisation-icon");

  if (!dateInput || !dateDisplay || !dateWrapper) return;

  // Fonction pour formater la date en français
  function formatDate(dateString) {
    if (!dateString) return "Délai de réalisation";

    const date = new Date(dateString + "T00:00:00");
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("fr-FR", options);
  }

  // Fonction pour mettre à jour l'affichage
  function updateDisplay() {
    const value = dateInput.value;
    if (value) {
      dateDisplay.textContent = formatDate(value);
    } else {
      dateDisplay.textContent = "Délai de réalisation";
    }
  }

  // Fonction pour ouvrir le date picker en simulant un clic
  function openDatePicker() {
    dateInput.showPicker();
  }

  // Initialiser l'affichage
  updateDisplay();

  // Écouter les clics sur la div wrapper et l'icône
  dateWrapper.addEventListener("click", function (e) {
    e.preventDefault();
    openDatePicker();
  });

  if (dateIcon) {
    dateIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDatePicker();
    });
  }

  // Mettre à jour l'affichage quand la date change
  dateInput.addEventListener("change", function () {
    updateDisplay();
  });

  // Mettre à jour l'affichage quand la date est modifiée (pour les navigateurs qui supportent l'input)
  dateInput.addEventListener("input", function () {
    updateDisplay();
  });
});

// Note: FAQ dropdown functionality is handled by default-template.js
// which is loaded on partner pages
